import { useCallback } from "react";

import { LocationAssociations } from "../models/associations";
import { useLocationPortalApi, useQueryWrapper } from "./locationPortalApi";
import * as Queries from "./queries";

export function useAssociationsApi() {
	const { Get, Post } = useLocationPortalApi();

	const getAssociations = useCallback(
		function (locationId: number, stateId?: number, marketer?: number) {
			return Get<LocationAssociations[]>("GetAssociations", { stateId, locationId, marketer });
		},
		[Get],
	);

	const saveAssociations = useCallback(
		function (locationId: number, associations: LocationAssociations[]) {
			return Post<LocationAssociations[]>("SaveAssociations", null, { locationId, associations });
		},
		[Post],
	);

	return { getAssociations, saveAssociations };
}

export function useAssociationsQueries(locationId: number) {
	const { getAssociations } = useAssociationsApi();
	const { ASSOCIATIONS } = Queries.LOCATION;

	const useAssociationsQuery = (stateId?: number, marketer?: number) =>
		useQueryWrapper(ASSOCIATIONS, [locationId, stateId, marketer], () =>
			getAssociations(locationId, stateId, marketer),
		);

	return { useAssociationsQuery };
}
